import { resolveTokensInText } from '@/services/mergeTokens';

/**
 * True when a resolved recipient still contains an unresolved `{...}` merge
 * token (e.g. `{client.email}` when the client has no email). Such entries must
 * not be used as real addresses, otherwise the literal token leaks into the To
 * field instead of falling back to the known client email.
 */
export function hasUnresolvedToken(value: string): boolean {
  return /\{[^}]+\}/.test(value);
}

/** Resolve template recipients, dropping empties and unresolved-token leftovers. */
export function resolveRecipients(
  addresses: string[] | undefined,
  data: Record<string, string>,
): string[] {
  return (
    addresses
      ?.map((a) => resolveTokensInText(a, data))
      .filter((a) => Boolean(a) && !hasUnresolvedToken(a)) ?? []
  );
}
